var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',[_c('v-list-item-avatar',{attrs:{"size":"32"}},[_c('v-img',{attrs:{"src":_vm.sender.thumb}})],1),_c('v-list-item-content',[_c('v-list-item-title',{domProps:{"textContent":_vm._s(_vm.sender.username)}}),_c('v-list-item-subtitle',{staticClass:"message-content",domProps:{"textContent":_vm._s(_vm.message.text)}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }